/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUser
 */
export interface ElementsUser {
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    allowChangingPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    allowWanLogin?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    readonly allowedFsPaths: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    readonly allowedFsWritePaths: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    readonly displayName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    readonly effectivePermissions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    email?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUser
     */
    expiry?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    fmBookmarks?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    fullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    gid?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    readonly groupPermissions: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    readonly hasPassword: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    home?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    isExternal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    isCloud?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    readonly isCloudDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    language?: ElementsUserLanguageEnum;
    /**
     * 
     * @type {Date}
     * @memberof ElementsUser
     */
    readonly lastSeen?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    readonly ldap?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    readonly ldapDn?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    passwordChangeRequired?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUser
     */
    permissions: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    shaperCeiling?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    shaperRate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    readonly syncId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUser
     */
    readonly totpEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof ElementsUser
     */
    uid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    unixUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUser
     */
    username: string;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserFromJSON(json: any): ElementsUser {
    return ElementsUserFromJSONTyped(json, false);
}

export function ElementsUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'allowChangingPassword': !exists(json, 'allow_changing_password') ? undefined : json['allow_changing_password'],
        'allowWanLogin': !exists(json, 'allow_wan_login') ? undefined : json['allow_wan_login'],
        'allowedFsPaths': json['allowed_fs_paths'],
        'allowedFsWritePaths': json['allowed_fs_write_paths'],
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'displayName': json['display_name'],
        'effectivePermissions': json['effective_permissions'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'expiry': !exists(json, 'expiry') ? undefined : (json['expiry'] === null ? null : new Date(json['expiry'])),
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'groupPermissions': json['group_permissions'],
        'hasPassword': json['has_password'],
        'home': !exists(json, 'home') ? undefined : json['home'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'isCloudDefault': json['is_cloud_default'],
        'isEnabled': !exists(json, 'is_enabled') ? undefined : json['is_enabled'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
        'ldap': !exists(json, 'ldap') ? undefined : json['ldap'],
        'ldapDn': !exists(json, 'ldap_dn') ? undefined : json['ldap_dn'],
        'passwordChangeRequired': !exists(json, 'password_change_required') ? undefined : json['password_change_required'],
        'permissions': json['permissions'],
        'shaperCeiling': !exists(json, 'shaper_ceiling') ? undefined : json['shaper_ceiling'],
        'shaperRate': !exists(json, 'shaper_rate') ? undefined : json['shaper_rate'],
        'syncId': json['sync_id'],
        'totpEnabled': json['totp_enabled'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'unixUsername': !exists(json, 'unix_username') ? undefined : json['unix_username'],
        'username': json['username'],
    };
}

export function ElementsUserToJSON(value?: ElementsUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allow_changing_password': value.allowChangingPassword,
        'allow_wan_login': value.allowWanLogin,
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'email': value.email,
        'expiry': value.expiry === undefined ? undefined : (value.expiry === null ? null : value.expiry.toISOString()),
        'fm_bookmarks': value.fmBookmarks,
        'full_name': value.fullName,
        'gid': value.gid,
        'home': value.home,
        'is_external': value.isExternal,
        'is_cloud': value.isCloud,
        'is_enabled': value.isEnabled,
        'language': value.language,
        'password_change_required': value.passwordChangeRequired,
        'permissions': value.permissions,
        'shaper_ceiling': value.shaperCeiling,
        'shaper_rate': value.shaperRate,
        'uid': value.uid,
        'unix_username': value.unixUsername,
        'username': value.username,
    };
}


